import React from 'react';
import { ConfidenceTag } from '../config/kinematicsBenchmarks';
import './ConfidenceTag.css';

interface ConfidenceTagProps {
  tag: ConfidenceTag;
}

const ConfidenceTagComponent: React.FC<ConfidenceTagProps> = ({ tag }) => {
  const getTagClass = () => {
    switch (tag) {
      case 'HIGH':
        return 'confidence-tag high';
      case 'MEDIUM':
        return 'confidence-tag medium';
      case 'PROXY':
        return 'confidence-tag proxy';
      case 'PLACEHOLDER':
        return 'confidence-tag placeholder';
      default:
        return 'confidence-tag';
    }
  };

  const getConfidenceText = () => {
    switch (tag) {
      case 'HIGH':
        return 'High';
      case 'MEDIUM':
        return 'Medium';
      case 'PROXY':
        return 'Proxy';
      case 'PLACEHOLDER':
        return 'Placeholder';
      default:
        return String(tag);
    }
  };

  // Only show confidence level for HIGH/MEDIUM (not PROXY/PLACEHOLDER)
  // PROXY/PLACEHOLDER are not confidence levels, they are data quality indicators
  if (tag === 'PROXY' || tag === 'PLACEHOLDER') {
    return null; // Hide confidence section for PROXY/PLACEHOLDER
  }

  return (
    <span className={getTagClass()} title="How certain the system is about the measurement from the video.">
      Confidence level: {getConfidenceText()}
    </span>
  );
};

export default ConfidenceTagComponent;




